import React, {PropTypes} from 'react';
import {Link} from 'react-router-dom';
import {FormattedDate} from 'react-intl';

class SmallEventCard extends React.Component {
  static propTypes = {
    cat: PropTypes.string,
    lang: PropTypes.string,
    name: PropTypes.string,
    photo: PropTypes.string,
    pk: PropTypes.number,
    rest: PropTypes.string,
    slug: PropTypes.string,
    start: PropTypes.string
  };
  /*
    constructor(props) {
      super(props);
      this.state = {
        description: ''
      };
    }
  */

  /*  componentDidUpdate(prevProps) {
      if(prevProps.description !== this.state.description){
        this.setState({description: this.props.description});
      }
    }*/

  /*  checkDescription() {
      var desc = this.state.description;

      //if there is an item description, truncate it to 7 words
      if(desc) {
        desc = desc.split(" ").splice(0,7).join(" ");
        return  (<p className="description">{desc}</p>)
      }
      else if(this.props.wineType) {
        return (<p className="description">{this.props.wineType}</p>)
      }
      else {
        return null
      }
    }*/

  render() {

    return (
      <Link to={'/' + this.props.lang + '/' + this.props.rest + `/items/` + this.props.cat + '/' + this.props.slug +
      '-' + this.props.pk + '/'}
            className="small-card">
        <div className="small-thumb"><img src={this.props.photo}/></div>
        <div className="item-content">
          <h4 className="small-item-title">{this.props.name}</h4>
          {/*{this.checkDescription()}*/}
          <div className="start-date price">
            <FormattedDate value={new Date(this.props.start)} year="numeric"
                           month="numeric" day="numeric" weekday="long"/>
          </div>
        </div>
      </Link>
    );
  }
}

export default SmallEventCard;



/** WEBPACK FOOTER **
 ** ./src/components/restaurant/SmallEventCard.js
 **/